module.exports = __webpack_public_path__ + "img/horizontal_4_2_3009.14b61aa8.png";